import type { FaireProductEntity } from "../../entity_types/product";

export const p_jfe8dk9nj3: FaireProductEntity = {
  token: "p_jfe8dk9nj3",
  type: "product",
  name: "pumpkin season greeting card",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/4fc35923c143701585bcf3ee731ab3fb0ae552d912ee2a0437e7b8648352c2ec.jpeg",
  galleryImageUrls: [],
  priceDollars: 3,
  description:
    'Celebrate all things pumpkin with the Pumpkin Season greeting card. The card is blank on the inside with charming watercolor illustrations on the front.\n\nDetails:\n\n- blank inside\n- 5.5" x 4.25"\n- Printed on 120lb superfine paper\n- Original watercolor artwork by Emily Lex\n',
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:14:47.866Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
